export const TRAININGS_QUALIFICATION_SELECT_PLACEHOLDER = "Formations";

export const TRAININGS_LIST_SELECT_FORMATION_MESSAGE = "Sélectionner une formation";

export const TRAININGS_EMPTY_SELECT_TEMPLATE_MESSAGE = "Sélectionnez un template pour le modifier.";
